import React from 'react';
import i18n from "i18next";
import { Button, Tooltip, Row, Col, Modal, message } from 'antd';
import { CloudSyncOutlined, FileAddOutlined, ArrowLeftOutlined, ImportOutlined,
  FileZipOutlined } from '@ant-design/icons'
import CatalogRepository from '../../components/adms/CatalogRepository'
import NewElement from '../../components/editor/NewElement';
import { RdfTriplet, DcatCatalogs, SkosScheme} from '../../redux';
import { getCountValue } from '../../virtuoso/helper';
import { makeURI } from '../../utils/uriUtil';
import { makePrefixIRIByType } from '../../utils/uriUtil';
import CatalogsFilter from '../../components/adms/CatalogsFilter';
import ImportConceptScheme from '../../components/import/ImportConceptScheme';
import ExportConceptScheme from '../../components/export/ExportConceptScheme';

const prefixURI = "http://www.w3.org/2004/02/skos/core#";
const predicatSkosDefinition = "http://www.w3.org/2004/02/skos/core#definition";

/**
 *  Отображение формы добавление нового элемента в каталоге
 * 
 *  Модальная форма на основе примера см. https://stackblitz.com/edit/ant-modal-form?file=index.js
 */
const showAdd = (formRef=f=>f, factory, onFinishOperation=f=>f, onCancelOperation=f=>f, sksaNamespace) => {
    const extra =[
    //см. 
    { "uri": predicatSkosDefinition, 
      rules:[{ required: true, message: 'Пожалуйста, укажите описание каталога' }]
    },
  ];

  return <Modal 
          style={{minWidth: 700}} 
          open={true} 
          title={i18n.t('views.admin.add_concept_scheme')} 
          cancelText="Отменить" 
          okText="Добавить" 
		      onCancel={onCancelOperation} 
          onOk={onFinishOperation}>	
        <NewElement 
          formRef={formRef}
          factory={factory}
          prefixURI={makePrefixIRIByType(sksaNamespace, "http://www.w3.org/2004/02/skos/core#ConceptScheme")}
          rdfType={"http://www.w3.org/2004/02/skos/core#ConceptScheme"}
          extra={extra}
          />          
	  </Modal>
}

/** Добавить условие в список. Для словий с одной схемой формируется массив значений */
const includedConditions = (conditions, condition) => {
  return conditions.concat([condition])
}
/** Исключить условие из поиска */
const excludedConditions = (conditions, condition) => {
  return conditions.filter(item => !((item.operator==condition.operator)&&(item.value==condition.value)));
}


/** Компонента для получения и отображения списка каталогов dcat:Catalog. 
 *  Доступные каталоги и графы фиксируются в vcatalogs.
 *  Линковка props и vcatalogs происходит в containers.js
 */
class SKSACatalogList extends React.Component {

    state = {
      modal: "none",		//Состояние модельного окна. none - не показывается, add - отобразить диалог добавление нового элемениа
    };

    formRef = React.createRef();

    componentDidMount() {
      const {conditions, lang} = this.props;
      this.props.onRefreshList(DcatCatalogs, conditions, lang);
    }
  
    onRefresh (e) {
      e.preventDefault();
      const {conditions, lang} = this.props;
      this.props.onRefreshList(DcatCatalogs, conditions, lang);
    }
    onNewScheme(e){
      e.preventDefault();
      this.setState({modal:"add"});
    }

    onShowCatalogInformation(e){
      e.preventDefault();
      this.setState({modal:"info"});
    }

  onImportDialog(e){
    e.preventDefault();
    this.setState({modal:"import"});
  }

  onExportDialog(e){
    e.preventDefault();
    this.setState({modal:"export"});
  }

  cancelOperation(){
    this.setState({modal:"none"});
  };

  //Событие об изменение состава условий отбора
  // include - true - добавить условие, false - удалить условие.
  // condition - само условие. 
  // Если условия из одного фильтра, то создать массив, который будет объединятся по ИЛИ
  onChangeListConditions (include, condition) {
    console.log(include, condition);
    const {conditions, onChangeConditions} = this.props;      
    let filter = conditions;
    if (Array.isArray(condition)){
      condition.forEach(item => 
        filter = (include)
          ? includedConditions(filter, item) 
          : excludedConditions(filter, item)
      );
    } else {
      filter = (include)
        ? includedConditions(conditions, condition) 
        : excludedConditions(conditions, condition);
    };      
    if (onChangeConditions) 
      onChangeConditions(DcatCatalogs, filter);
  };
  
  /** Вызывается при добавлении нового классификатора. Данные см. NewElement.js */
  submitOperation() {
    const { sksaNamespace, router, onSelected } = this.props;
    const form  = this.formRef.current;
    form.validateFields()
      .then(values => {
        //console.log("ConceptSchemeList.js submitOperation() Received values of form: ", values);
        const IRI = (values.IRI.startsWith("http://") || values.IRI.startsWith("https://"))
            ? values.IRI : makeURI(sksaNamespace, values.IRI);
        //Проверим, что IRI отсутствует
        RdfTriplet.countSubject(IRI)
          .then ( response =>{
            const count = getCountValue(response.bindings);
            if (count>0){
              message.error(`URI ${IRI} уже существует. Задайте другой идентификатор.`);
              return;
            }
            //Добавление всегда идёт в каталог, который доступен для зарегистрированных пользователей
            const label = values["http://www.w3.org/2000/01/rdf-schema#label"];
            const rdfType = values["http://www.w3.org/1999/02/22-rdf-syntax-ns#type"];
            //console.log("ConceptSchemeList.js submitOperation() ", IRI, rdfType, label.text, label.lang);
            const requests = [
              this.props.onAddElement(DcatCatalogs, IRI, rdfType, label.text, label.lang),
              this.props.onInsertProperty(SkosScheme, IRI, predicatSkosDefinition, values[predicatSkosDefinition], label.lang)
            ];            
            Promise.all(requests)
              .then (response =>{ 
                //const time = showMessageSuccess(store, "Добавление записи завершено успешно.");
                message.success("Добавление записи завершено успешно.");
                this.setState({modal:"none"}); 
                if (router && onSelected)
                  onSelected(IRI, SkosScheme, router.navigate)                    
              })
              .catch(e => {  message.error(`Ошибка при добавлении элемента в каталог. ${e}`); });                  
          })
          .catch(e => {  
            message.error(`Не удалось определить уникальность IRI. ${e}`); 
          });
      })
      .catch(info => {
        message.error(i18n.t('skos.scheme.message.e_new', {detail: info}));
      });

    };
    
    render() {
        console.log(this);
        const { modal } = this.state;
        const {isSignedIn, inGroup, factory, conditions, sksaNamespace, graphs} = this.props;
        return (
            <div>
              <Row><h1>{i18n.t('views.admin.landing.catalogs')}</h1></Row>
                <Row>
                    <Col className="csi_filters" span={6} style={{}}>
                        {/* {isCondition && (
                          <Row style={{}} className="filterBrowserDiv"> <FilterData actions={VocabsRepository} onChange={(i,c)=> this.onChangeListConditions(i,c)}/></Row>
                          )} */}
                        <Row style={{}}> 
                          <CatalogsFilter
                            graphs={graphs} selected={conditions} 
                            onChange={(i,c)=> this.onChangeListConditions(i,c)}                            
                          />
                        </Row>
                    </Col>
                    <Col className="csi_asset_list" span={18} style={{}}>
                        <Row>
                          <Col span={22}>                          
                              <Tooltip placement="top" title={i18n.t('views.admin.return_admin_panel')}>
                                <Button icon={<ArrowLeftOutlined />} onClick={(e)=> this.props.router.navigate("/")}></Button>
                              </Tooltip>
                              &nbsp;&nbsp;
                              <Tooltip placement="top" title={i18n.t('views.adms.list_reload_title')}>
                                  <Button icon={<CloudSyncOutlined />} onClick={(e)=> this.onRefresh(e)}></Button>
                                </Tooltip>
                            </Col>
                            {/* <Col span={2} style={{"display": "flex", "flexDirection": "row-reverse"}}>
                              {isSignedIn && inGroup.PowerUser && (
                                <>
                                  <Tooltip placement="top" title={i18n.t('views.admin.add_concept_scheme')}>
                                    <Button icon={<FileAddOutlined />} onClick={(e)=> this.onNewScheme(e)}></Button>
                                  </Tooltip>
                                  &nbsp;&nbsp;
                                  <Tooltip placement="top" title={i18n.t('views.admin.import_conceptscheme')}>
                                    <Button icon={<ImportOutlined />} onClick={(e)=> {(this.onImportDialog(e))}} ></Button> 
                                  </Tooltip>
                                  &nbsp;&nbsp;
                                  <Tooltip placement="top" title={i18n.t('views.adms.export_card')}>
                                    <Button icon={<FileZipOutlined />} onClick={(e)=> this.onExportDialog(e)}/>
                                  </Tooltip>                              
                                </>
                              )}
                            </Col> */}
                        </Row>
                        <Row id="CatalogRepository" ><Col span={24}><CatalogRepository {...this.props} /></Col></Row>
                    </Col>
                </Row>
                { modal=="add" && showAdd( this.formRef, factory, ()=>this.submitOperation(), ()=>this.cancelOperation(), sksaNamespace)}
                { modal=="import" && <ImportConceptScheme open={true} onClose={()=> this.cancelOperation()} />}
                { modal=="export" && <ExportConceptScheme open={true} onClose={()=> this.cancelOperation()} conditions={conditions}/>}
            </div>            
        )
    }
}

export default SKSACatalogList;